import PropTypes from 'prop-types';
import styled from 'styled-components';
import { reduxPropTypes } from '@figure/frontlib-onboarding-redux';
import { Spinner, Typography } from '@figure/frontlib-gui';
import { IncomeList, IncomeListItem, PlaidDelete, PlaidError } from './';

const SmallSpinner = styled(Spinner)`
  width: 1.6rem;
  height: 1.6rem;
  border-width: 2px;
  position: relative;
  top: 2px;
`;

const ProgressList = ({ items, incomeRequests, handleDelete, handleRetry, offerPackage }) => {
  const { plaidItemUuids = [] } = offerPackage;
  const itemStatus = items
    .map((item) => ({
      uuid: item.uuid,
      completed: item.assetsComplete && plaidItemUuids.includes(item.uuid),
      errored: item.assetsFailed,
    }))
    .reduce((aggregate, curr) => ({ ...aggregate, [curr.uuid]: curr }), {});

  const renderItemState = (item) => {
    const status = itemStatus[item.uuid];

    if (status.completed) {
      return <p>Done</p>;
    } else if (!item.inProgress && status.errored) {
      return <PlaidDelete handleClick={() => handleDelete(item)} />;
    }
    return (
      <Typography.SmallBody>
        Retrieving info <SmallSpinner />
      </Typography.SmallBody>
    );
  };

  const renderIncomeState = (item) => (
    <Typography.SmallBody>
      {item.completed ? (
        'Done'
      ) : (
        <>
          Retrieving info <SmallSpinner />
        </>
      )}
    </Typography.SmallBody>
  );

  return (
    <IncomeList>
      {incomeRequests.map((item) => (
        <IncomeListItem
          key={item.uuid}
          category={item.verificationMethod?.indexOf('TAX') > -1 ? 'Tax return' : 'Paystub'}
          completed={item.completed}
        >
          {renderIncomeState(item)}
        </IncomeListItem>
      ))}
      {items.map((item) => (
        <IncomeListItem
          key={item.uuid}
          category={
            <>
              {item.institution}
              {item.assetsFailed && (
                <PlaidError
                  text="(We had trouble connecting to the account.)"
                  handleRetry={
                    item.retryable || item.loginRequired ? () => handleRetry(item) : null
                  }
                />
              )}
            </>
          }
          completed={itemStatus[item.uuid].completed}
          errored={itemStatus[item.uuid].errored}
        >
          {renderItemState(item)}
        </IncomeListItem>
      ))}
    </IncomeList>
  );
};

ProgressList.propTypes = {
  items: PropTypes.arrayOf(reduxPropTypes.plaidItem).isRequired,
  incomeRequests: PropTypes.arrayOf(reduxPropTypes.incomeRequest).isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleRetry: PropTypes.func.isRequired,
  offerPackage: reduxPropTypes.offerPackage.isRequired,
};

export default ProgressList;
